import React from "react";
import {EntitiesStore} from "../../../stores/entities";
import {connectDiscriminated} from "../../utils/aj";
import AbstractEntitiesGrid from "./abstractEntitiesGrid";

export default class EntitiesGrid extends AbstractEntitiesGrid {

}

